export const GuideMainData = [
    {
        id: 1,
        text: '자주찾는질문',
        name: 'Faq',
    },
    {
        id: 2,
        text: '서비스 이용약관',
        name: 'TermsOfUse',
    },
    {
        id: 3,
        text: '개인정보 처리방침',
        name: 'PrivacyPolicy',
    },
];